module.exports = __webpack_public_path__ + "img/2300-1_YR_2022_WebsitesAndLinks.bed08ac1.png";